import React from 'react';

import useStyles from './TextMedia.style';

interface TextMediaProps {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export const TextMedia: React.FC<TextMediaProps> = (props) => {
  const { children, className, style } = props;
  const { classes, cx } = useStyles({});

  return (
    <div
      className={cx(classes.textMediaWrapper, className)}
      style={style}
    >
      {children}
    </div>
  );
};

interface TextProps {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export const Text: React.FC<TextProps> = (props) => {
  const { children, className, style } = props;
  const { classes, cx } = useStyles({});

  return (
    <div
      className={cx(classes.textWrapper, className)}
      style={style}
    >
      {children}
    </div>
  );
};

interface MediaProps {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  orientation?: 'left' | 'right';
  caption1?: string | React.ReactElement | React.ReactElement[];
  caption2?: string | React.ReactElement | React.ReactElement[];
}

export const Media: React.FC<MediaProps> = (props) => {
  const { children, className, style, orientation='left', caption1, caption2 } = props;
  const { classes, cx } = useStyles({ orientation });

  return (
    <div
      className={cx(classes.mediaWrapper, className)}
      style={style}
    >
      <div className={classes.mediaWrapperInner}>
        {caption1 && (
          <span className={orientation === 'left' ? classes.mediaCaption1Left : classes.mediaCaption1Right}>
            {caption1}
          </span>
        )}

        {caption2 && (
          <span className={orientation === 'left' ? classes.mediaCaption2Left : classes.mediaCaption2Right}>
            {caption2}
          </span>
        )}

        {children}
      </div>
    </div>
  );
};

export default TextMedia;
